module.exports = __webpack_public_path__ + "img/pe.a918b89b.jpg";